import styled from 'styled-components';

import { Button as CommonButton } from '@rewardopl/react-ui/button/index.styles';

export const Button = styled(CommonButton)`
  --secondary-button-border-width: 1px;
  display: inline-block;
  background: white;
  border-color: #747775;
  color: black;

  &:hover, &:focus {
    background: #eee;
    color: black;
  }

  &:focus-visible {
    background: #eee;
    color: black;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  position: relative;
  top: -1px;
  margin-right: 12px;
  vertical-align: -26%;
`;
